import { AutoComplete,  Form } from "antd"
import { useCallback, useEffect, useMemo, useState } from "react"
import { useThrottleEffect } from "ahooks";
import { Page } from "../../constants/common";
import { Partner } from "../../constants/partners";
import { StatusFilterTree } from "./statusfilter";
import { DataNode } from "antd/lib/tree";
import requestor from "../../requestor"

let options_provider = [
  { value: '人保' },
  { value: '平安' },
  { value: '鼎和' },
];

let options_driverCompany = [
  { value: '拖车侠' },
  { value: '修理厂' },
];



const Auto = ({ options, onChange }: { options?: { value: string }[], onChange: (v: string) => void }) => {
  return <AutoComplete
    style={{ width: 200 }}
    options={options}
    placeholder="请输入或者选择搜索"
    filterOption={(inputValue, option) =>
      option!.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
    }
    onChange={onChange}
  />
}

export const SearchFormItemTags = ({ name, onChange }: { name: string, onChange: (v: DataNode[]) => void }) => {
  const [partners, setPartners] = useState<Partner[]>([]);
  const [value, setValue] = useState<string>('');


  const pagePartners = useCallback(
    async (value: string = "") => {
      let page = 1;
      let size = 12;
      let where: string = encodeURIComponent(`(\`name\` like '%${value.trim()}%' or \`alias\` like '%${value.trim()}%')`);

      try {
        const res = await requestor.pagePartners<Page<Partner>>(page, size, where);
        if (res.error !== "") {
          throw new Error(res.error);
        }
        if (res.result) {
          setPartners(res.result.payload)
        }
      } catch (e) {
      }
    },
    []
  );

  useThrottleEffect(
    () => {
      if (value) {
        pagePartners(value)
      }
    },
    [value],
    {
      wait: 800,
    },
  );

  useEffect(() => {
    let options = partners.map(d => ({
      title: d.name.replace("中国人民财产保险股份有限公司", "人保")
        .replace("中国平安财产保险股份有限公司", "平安"),
      key: d.id
    }))
    onChange(options)
  }, [partners])

  let autoOptions = useMemo(() => {
    return name === 'driverCompany' ? options_driverCompany : options_provider
  }, [name])

  return <Form.Item name="autoName" style={{ marginBottom: '0px' }}>
    <Auto options={autoOptions} onChange={(v) => { setValue(v); }} />
  </Form.Item>
}

export const FilterPartnerTree = ({ name, onChange, registerReset }: { name: string, onChange: (value: (string | number)[]) => void, registerReset: (resetFun: () => void) => void }) => {

  const [options, setOptions] = useState<DataNode[]>([])

  const formprops = {
    label: "",
    name: name,
    placeholder: "请输入关键字检索后选择企业"
    // initKeyword: "拖车侠"
  }
  return <Form layout="vertical">
    <SearchFormItemTags {...formprops} onChange={(v) => setOptions(v)} />
    <StatusFilterTree noFormwrapper={true} treeData={options} onChange={onChange} registerReset={registerReset} multiple={true} />
  </Form>
}